var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 5.33334H23.9999C24.7072 5.33334 25.3854 5.61429 25.8855 6.11438C26.3856 6.61448 26.6666 7.29276 26.6666 8V26.6667C26.6666 27.3739 26.3856 28.0522 25.8855 28.5523C25.3854 29.0524 24.7072 29.3333 23.9999 29.3333H7.99992C7.29267 29.3333 6.6144 29.0524 6.1143 28.5523C5.6142 28.0522 5.33325 27.3739 5.33325 26.6667V8C5.33325 7.29276 5.6142 6.61448 6.1143 6.11438C6.6144 5.61429 7.29267 5.33334 7.99992 5.33334H10.6666",
    stroke: "url(#paint0_linear_107_168)",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 2.66666H12.0001C11.2637 2.66666 10.6667 3.26362 10.6667 4V6.66666C10.6667 7.40304 11.2637 8 12.0001 8H20.0001C20.7365 8 21.3334 7.40304 21.3334 6.66666V4C21.3334 3.26362 20.7365 2.66666 20.0001 2.66666Z",
    stroke: "url(#paint1_linear_107_168)",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_168",
    x1: 15.9999,
    y1: 5.33334,
    x2: 15.9999,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#134A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13675f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_168",
    x1: 16.0001,
    y1: 2.66666,
    x2: 16.0001,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#134A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13675f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.899ade84d3373e231f996dce085fd375.svg";
export { ForwardRef as ReactComponent };